import React, { useState, useEffect } from "react";
import { Stack, Button } from "@mui/material";
import { themeOrange } from "../../utils/colorTheme";

const ShiftsSelector = ({
  selectedDate,
  onShiftSelect,
  allDates,
  initialShifts,
  spacing = 2,
  isModal = false,
}) => {
  const [selectedShifts, setSelectedShifts] = useState(initialShifts || []);

  const shifts = [
    { label: "Morning", time: "09:00 AM" },
    { label: "Afternoon", time: "01:00 PM" },
    { label: "Evening", time: "06:00 PM" },
  ];

  useEffect(() => {
    if (!initialShifts || initialShifts.length === 0) {
      const defaultShift = "Morning";
      setSelectedShifts([defaultShift]);
      onShiftSelect(selectedDate, [defaultShift]);
    } else {
      setSelectedShifts(initialShifts);
    }
  }, [initialShifts, selectedDate]);

  const isOnlyTodayInArray = () => {
    const today = new Date().toDateString();
    return (
      allDates.length === 1 && new Date(allDates[0]).toDateString() === today
    );
  };

  const _modalShiftsDisabled = (shiftTime) => {
    if (!isOnlyTodayInArray()) return false;

    const now = new Date();
    const today = new Date().toDateString();
    const selectedDay = new Date(selectedDate).toDateString();

    if (today !== selectedDay) {
      return false;
    }

    const [hours, minutesPart] = shiftTime.split(":");
    const minutes = parseInt(minutesPart.slice(0, 2));
    const ampm = shiftTime.slice(-2);
    const shiftDate = new Date();

    shiftDate.setHours(
      ampm === "PM" && hours !== "12" ? parseInt(hours) + 12 : parseInt(hours)
    );
    shiftDate.setMinutes(minutes);
    shiftDate.setSeconds(0);
    shiftDate.setMilliseconds(0);

    return now > shiftDate;
  };

  const _isShiftDisabled = (shiftTime) => {
    const today = new Date();
    const selectedDay = new Date(selectedDate).toDateString();

    if (selectedDay !== today.toDateString()) {
      return false;
    }

    const [hours, minutesPart] = shiftTime.split(":");
    const minutes = parseInt(minutesPart.slice(0, 2));
    const ampm = shiftTime.slice(-2);
    const shiftDate = new Date();

    shiftDate.setHours(
      ampm === "PM" && hours !== "12" ? parseInt(hours) + 12 : parseInt(hours)
    );
    shiftDate.setMinutes(minutes);
    shiftDate.setSeconds(0);
    shiftDate.setMilliseconds(0);

    return today > shiftDate;
  };

  const handleShiftToggle = (shift) => {
    let updatedShifts;
    if (selectedShifts.includes(shift)) {
      updatedShifts = selectedShifts.filter((s) => s !== shift);
    } else {
      updatedShifts = [...selectedShifts, shift];
    }
    setSelectedShifts(updatedShifts);
    onShiftSelect(selectedDate, updatedShifts);
  };

  return (
    <Stack spacing={2}>
      <Stack
        alignItems={"center"}
        justifyContent={"space-between"}
        direction="row"
        gap={spacing}
        flexWrap={"wrap"}
      >
        {shifts.map(({ label, time }) => {
          const isSelected = selectedShifts.includes(label);
          const isDisabled = isModal
            ? _modalShiftsDisabled(time)
            : _isShiftDisabled(time);
          return (
            <Button
              disabled={isDisabled}
              key={label}
              variant={isSelected ? "contained" : "outlined"}
              onClick={() => handleShiftToggle(label)}
              sx={{
                backgroundColor: isSelected ? themeOrange : "white",
                borderColor: themeOrange,
                color: isSelected ? "white" : themeOrange,
                ":hover": {
                  borderColor: themeOrange,
                  backgroundColor: isSelected ? themeOrange : "white",
                },
                padding: {
                  xl: "9.8px 15px",
                  lg: "9.8px 15px",
                  md: "9.8px 15px",
                  sm: "7px 10px",
                  xs: "5px 8px",
                },
                textTransform: "capitalize",
                fontSize: {
                  xl: "13px",
                  lg: "13px",
                  md: "13px",
                  sm: "12px",
                  xs: "10px",
                },
              }}
            >
              {label}
            </Button>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default ShiftsSelector;
